import { render, staticRenderFns } from "./TextBodyExtraSmall.vue?vue&type=template&id=47dfd15f&scoped=true"
import script from "./TextBodyExtraSmall.vue?vue&type=script&lang=js"
export * from "./TextBodyExtraSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dfd15f",
  null
  
)

export default component.exports